import React from "react";
import StudentPlacementHistory from "../Studentpage/StudentPlacementHistory";

const PlacementSection = ({ studentData, warnings = [], onShowWarnings }) => {

    const placement = studentData?.courseDetails || studentData;

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return isNaN(date.getTime())
            ? "-"
            : date.toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            });
    };

    const hasWarnings = warnings.length > 0;

    return (
        <div>

            {/* ⚠ Placement Warning */}
            {hasWarnings && (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "10px",
                        padding: "10px",
                        border: "1px solid #ffc107",
                        borderRadius: "6px",
                        background: "#fff8e1",
                        cursor: "pointer",
                        fontWeight: "600",
                        color: "#b26a00"
                    }}
                    onClick={() => onShowWarnings(warnings)}
                >
                    ⚠ Placement chance is low — Click to view missing details
                </div>
            )}

            <div className="placements-table">
                <table>
                    <thead>
                        <tr>
                            <th colSpan="2">Placement Details</th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td>Placement Status</td>
                            <td>{placement.placementStatus || " "}</td>
                        </tr>

                        {placement.placementStatus !== "Placed" && (
                            <>
                                <tr>
                                    <td>Interest of Placement</td>
                                    <td>{placement.placementInterest || "-"}</td>
                                </tr>

                                {placement.placementInterest &&
                                    placement.placementInterest !== "High" && (
                                        <tr>
                                            <td>Additional Notes</td>
                                            <td>{placement.staffRemarks || "-"}</td>
                                        </tr>
                                    )}
                            </>
                        )}

                        {placement.placementStatus === "Placed" && (
                            <>
                                <tr>
                                    <td>Company Name</td>
                                    <td>{placement.companyName || "-"}</td>
                                </tr>
                                <tr>
                                    <td>Company Location</td>
                                    <td>{placement.companyLocation || "-"}</td>
                                </tr>
                                <tr>
                                    <td>Date of Placement</td>
                                    <td>{formatDate(placement.placementDate)}</td>
                                </tr>
                                <tr>
                                    <td>Job Role</td>
                                    <td>{placement.jobRole || "-"}</td>
                                </tr>
                                <tr>
                                    <td>Package</td>
                                    <td>{placement.package || "-"}</td>
                                </tr>
                                <tr>
                                    <td>Joining Date</td>
                                    <td>{formatDate(placement.joiningDate)}</td>
                                </tr>
                                <tr>
                                    <td>Placed By</td>
                                    <td>{placement.placedBy || "-"}</td>
                                </tr>
                            </>
                        )}

                    </tbody>
                </table>
            </div>

            {studentData.studentId && (
                <StudentPlacementHistory studentId={studentData.studentId} />
            )}

        </div>
    );
};

export default PlacementSection;